<template>
    <div>
        <h5 class="mb-4">
            <strong>Reglas de pictogramas</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Regla">
                    <b-form-input v-model="filterRulesPictogramsSga.name" type="text" placeholder="Buscar por nombre"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterRulesPictogramsSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchRulesPictogramsSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <b-button v-if="canManageConfiguration" variant="primary" @click="createRulePictogram">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva regla de pictograma'" />
                    </b-button>
                </b-form-group>
            </b-col>

            <b-modal id="modal_create_rulepictograms" size="md" hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} regla de pictograma
                </template>
                <formRulesPictograms />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="rulesPictogramsSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        
                        <!-- Versión del SGA -->
                        <template #cell(edition)="data">
                            <b-badge variant="info" class="text-white">
                                {{ data.item.version_sga && typeof data.item.version_sga === 'object' ? data.item.version_sga.version : 'No registra' }}
                            </b-badge>
                        </template>
                        <!-- Subcategorías -->
                        <template #cell(sub_categories)="data">
                            <ul class="m-0 p-0 pl-2" v-if="data.item.subCategories && typeof data.item.subCategories === 'object' && data.item.subCategories.length > 0">
                                <li v-for="(subCategory, index) in data.item.subCategories" :key="index">
                                    {{ subCategory.name }}
                                </li>                                
                            </ul>
                            <span v-else class="list-unstyled">
                                No registra
                            </span>
                        </template>

                        <template #cell(pictogramCombinations)="data">
                            <b-img v-for="(pictogram, index) in data.item.pictogramCombinations" :key="index"
                                :src="pictogram.image" :alt="pictogram.name" style="max-width: 50px; max-height: 50px;"
                                class="mr-1" />
                        </template>
                        <template #cell(pictogramsToDisplay)="data">
                            <b-img v-for="(pictogram, index) in data.item.pictogramsToDisplay" :key="index"
                                :src="pictogram.image" :alt="pictogram.name" style="max-width: 50px; max-height: 50px;"
                                class="mr-1" />
                        </template>
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editRulePictogram(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterRulesPictogramsSga.page"
                            :total="filterRulesPictogramsSga.total" :current-page="filterRulesPictogramsSga.page"
                            :page-size="filterRulesPictogramsSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formRulesPictograms from './FormRulesPictograms.vue';
export default {
    name: 'rulesPictograms',
    components: {
        formRulesPictograms,
    },
    data() {
        return {            
        };
    },

    computed: {
        ...mapState('sgaRulesPictograms', ['rulesPictogramsSga', 'action', 'filterRulesPictogramsSga']),
        ...mapState('sgaVersions', ['statesSga', 'activeGlobalVersion', 'activeVersions']),
        canManageConfiguration() {
            const activeVersion = this.activeVersions && this.activeVersions.find(v => v.id === this.activeGlobalVersion);
            
            const isVersionLocked = (activeVersion && activeVersion.is_locked) || false;
            
            return !isVersionLocked;
        },
         fields() {
            const baseFields = [
                {
                    key: "edition",
                    label: "Edición",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "name",
                    label: "Descripción",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "sub_categories",
                    label: "Subcategorías",
                    sortable: true,
                    thClass: "text-center",
                },
                {
                    key: "pictogramCombinations",
                    label: "Combinación",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "pictogramsToDisplay",
                    label: "Visibles",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ];

            if (this.canManageConfiguration) {
                baseFields.push({
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                });
            }

            return baseFields;
        }
    },

    watch: {

        'activeGlobalVersion'(next, prev) {
            if (next != prev && next) {
                this.setEditionToFilterRulesPictogramsSga(this.activeGlobalVersion)
                this.searchRulesPictogramsSga();
            }
        }

    },

    methods: {
        ...mapActions('sgaRulesPictograms', ['getRulesPictogramsSga', 'changeStatusRulePictogramSga', 'showRulePictogramSga']),
        ...mapMutations('sgaRulesPictograms', ['setActionRulePictogramSga', 'setDefaultFilterRulesPictogramsSga', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination', 'setEditionToFilterRulesPictogramsSga']),

        createRulePictogram() {
            this.setActionRulePictogramSga('create');
            this.$bvModal.show('modal_create_rulepictograms');
        },

        async clearFilter() {
            this.setDefaultFilterRulesPictogramsSga();
            this.setEditionToFilterRulesPictogramsSga(this.activeGlobalVersion)
            await this.getRulesPictogramsSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getRulesPictogramsSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getRulesPictogramsSga();
        },

        async changeStatus(id) {
            await this.changeStatusRulePictogramSga(id);
            await this.getRulesPictogramsSga();
        },

        editRulePictogram(rulePictogram) {
            this.showRulePictogramSga(rulePictogram.id);
            this.setActionRulePictogramSga('edit');
            this.$bvModal.show('modal_create_rulepictograms');
        },

        async searchRulesPictogramsSga() {
            await this.getRulesPictogramsSga(true);
        },
    },
};
</script>
